import React from 'react';
import './ErrorPage.scss';
import SpinnerSga from '../UI/SpinnerSga';

const NoContent204 = ({ urlParams }) => {
    return (
        <section className="error-page">
            <div className="description">
                <p className="gray-text without-transform">Upps... coś poszło nie tak</p>
                <div className="container">
                    <p className="code">#204</p>
                    <p className="break-text">
                        <span>Brak</span>
                        <span>danych</span>
                    </p>
                </div>
                <p className="uppercase-text">Brak danych do wyświetlenia!</p>
                <p className="text">Wygląda na to, że aplikacja nie może pobrać danych, aby być poprawnie wyświetlona. Sprawdź poprawność adresu URL!</p>
                <div className="url-info">
                    {/* <p className="text">Próbujesz pobrać dane dla: </p>
                    <p className="sm-margin">ID Szpitala: <span className="text url-code">{urlParams.hospID}</span> </p>
                    <p className="sm-margin">ID Odziału: <span className="text url-code">{urlParams.wardID}</span> </p>
                    <p className="sm-margin">Zakres (od): <span className="text url-code">{urlParams.rangeFrom}</span> </p>
                    <p className="sm-margin">Zakres (do): <span className="text url-code">{urlParams.rangeTo}</span> </p> */}
                </div>
                <p className="text padding">W przypadku poprawnych danych prosimy o kontakt:</p>
                <address className="address">
                    <dl className="contact">
                        <dt className="contact__list">
                            <i className="material-icons">mail_outline</i> <a className="list__item" href="mailto:sga@sga.waw.pl">sga@sga.waw.pl</a>
                        </dt>
                        <dt className="contact__list">
                            <i className="material-icons">phone</i> <a className="list__item" href="tel:81-534-21-05">(81) 534 21 05</a>
                        </dt>
                    </dl>
                </address>
            </div>
            <SpinnerSga />
        </section>
    );
}

export default NoContent204;